import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "venueWideRadio",
    "specificPractitionerRadio",
    "specificResourceRadio",
    "practitionerSelect",
    "resourceSelect",
    "oneTimeRadio",
    "oneTimeFields",
    "weeklyRadio",
    "weeklyFields",
    "annualRadio",
    "annualFields",
    "allDayCheckbox",
    "timeFields"
  ]

  scopeChanged() {
    this.practitionerSelectTarget
      .style.display = "none"
    this.resourceSelectTarget
      .style.display = "none"

    const practitionerSelect =
      this.practitionerSelectTarget
        .querySelector("select")
    const resourceSelect =
      this.resourceSelectTarget
        .querySelector("select")

    if (
      this.specificPractitionerRadioTarget.checked
    ) {
      this.practitionerSelectTarget
        .style.display = "block"
      if (resourceSelect) resourceSelect.value = ""
    } else if (
      this.specificResourceRadioTarget.checked
    ) {
      this.resourceSelectTarget
        .style.display = "block"
      if (practitionerSelect) {
        practitionerSelect.value = ""
      }
    } else {
      if (practitionerSelect) {
        practitionerSelect.value = ""
      }
      if (resourceSelect) resourceSelect.value = ""
    }
  }

  blockTypeChanged() {
    this.oneTimeFieldsTarget
      .style.display = "none"
    this.weeklyFieldsTarget
      .style.display = "none"
    this.annualFieldsTarget
      .style.display = "none"

    if (this.oneTimeRadioTarget.checked) {
      this.oneTimeFieldsTarget
        .style.display = "grid"
    } else if (this.weeklyRadioTarget.checked) {
      this.weeklyFieldsTarget
        .style.display = "block"
    } else if (this.annualRadioTarget.checked) {
      this.annualFieldsTarget
        .style.display = "grid"
    }
  }

  allDayChanged() {
    if (this.allDayCheckboxTarget.checked) {
      this.timeFieldsTarget
        .style.display = "none"
    } else {
      this.timeFieldsTarget
        .style.display = "grid"
    }
  }
}
